import type { ProviderRequestTypeEnum } from "@/api/generated/types.gen";

/** Request-type pill tabs, in the order the design shows them. */
export const REQUEST_TYPE_TABS: {
  id: ProviderRequestTypeEnum;
  label: string;
}[] = [
  { id: "records", label: "Records" },
  { id: "medical_report", label: "Medical report" },
  { id: "work_capacity", label: "Work capacity" },
];

/** Consent files accepted for the ClientAuth attach control. */
export const CONSENT_ACCEPT = ".pdf,.doc,.docx,.png,.jpg,.jpeg";

/**
 * Backend status enum → referrer-facing lifecycle label + chip styling.
 * The design's Requested → Receiving → Complete maps onto the persisted
 * SUBMITTED → IN_PROGRESS → COMPLETED states.
 */
export const REQUEST_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Draft",
  SUBMITTED: "Requested",
  IN_PROGRESS: "Receiving",
  COMPLETED: "Complete",
  FAILED: "Failed",
};

export const REQUEST_STATUS_CHIP: Record<string, string> = {
  DRAFT: "bg-foreground-muted/10 text-foreground-muted",
  SUBMITTED: "bg-primary/10 text-primary",
  IN_PROGRESS: "bg-amber-100 text-amber-700",
  COMPLETED: "bg-green-100 text-green-700",
  FAILED: "bg-red-100 text-red-700",
};
